import { easing, EaseCurve, EaseType } from '../lib/easing'
import Interval from '../lib/Interval'
import { lerp } from '../lib/math'

type NumberValues = {
	delay: number
	decimals: number
	duration: number
	element: HTMLElement
	from: number
	interval?: Interval
	prefix?: string
	suffix?: string
	to: number
}

export default class RisingNumber {
	private readonly values: NumberValues[]

	public constructor(public readonly element: HTMLElement) {
		if (!element) {
			throw new Error('No element given.')
		}

		this.element = element

		// Grab values.
		this.values = Array.from(this.element.querySelectorAll('span.value'))
			.map((element: HTMLElement) => {
				if (element.dataset.to === undefined) {
					return null
				}

				const obj: NumberValues = {
					element,
					from: +element.dataset.from || 0,
					to: +element.dataset.to || 0,
					decimals: +element.dataset.decimals || 0,
					duration: +element.dataset.duration || 3000,
					delay: +element.dataset.delay || 0,
					prefix: element.dataset.prefix || '',
					suffix: element.dataset.suffix || '',
				}
				element.textContent = obj.prefix + obj.from + obj.suffix
				return obj
			})
			.filter(element => element)
	}

	public startAnimation () {
		for (const obj of this.values) {
			const { element, from, to, delay, duration, decimals } = obj
			obj.interval = new Interval({ duration, delay }, (pos) => {
				if (!this.element.classList.contains('visible')) {
					this.element.classList.add('visible')
				}

				const ease = easing(pos, EaseType.Out, EaseCurve.Expo)
				let value = lerp(from, to, ease)
				const modifier = 10 ** decimals || 1

				value = Math.round(value * modifier) / modifier
				let integer: string | number = Math.floor(value)
				// let fract = Math.round((value - integer) * modifier)

				if (integer >= 1000) {
					const index = integer.toString().length
					integer = spliceString(integer.toString(), index - 3, 0, ',')
				}

				const valueString = decimals ? `${value.toFixed(decimals)}` : integer
				element.textContent = obj.prefix + valueString + obj.suffix
			})
			obj.interval.start()
		}
	}
}

function spliceString(string: string, start: number, delCount: number = 0, newSubStr: string = ''): string {
	return string.slice(0, start) + newSubStr + string.slice(start + Math.abs(delCount))
}
